import Modal from "../../../shared/Modal";
import { map } from "lodash";
import { ActivityLike } from "../../../../@types/activities.ts";

type LikesModalArgs = {
  likes: ActivityLike[];
  close: () => void;
};

export default function LikesModal({ likes, close }: LikesModalArgs) {
  return (
    <Modal title={I18n.t("js.activity.likes.title")} onClose={close}>
      <div className="flex flex-col gap-2 max-h-[500px] overflow-y-auto">
        {map(likes, ({ displayName, url, images, id }) => (
          <a
            key={id}
            className="flex flex-1 gap-2 member-link"
            href={url}
            title={displayName}
          >
            <img
              className="h-7 thumb-small w-7"
              src={images["40x40@2"]}
              alt={displayName}
            />
            {displayName}
          </a>
        ))}
      </div>
    </Modal>
  );
}
